import { useTab } from '@react-aria/tabs'
import { TabListState } from '@react-stately/tabs'
import cx from 'classnames'
import Styles from './Tab.module.scss'
import { useObjectRef } from 'utils/useObjectRef'
import { Node } from '@react-types/shared'

interface Props<T> {
  item: Node<T>
  state: TabListState<T>
}

export const Tab = <T,>({ item, state }: Props<T>) => {
  const { key, rendered } = item
  const ref = useObjectRef<HTMLDivElement | null>()
  const { tabProps } = useTab({ key }, state, ref)
  const isSelected = state.selectedKey === key
  const isDisabled = state.disabledKeys.has(key)

  return (
    <div
      {...tabProps}
      ref={ref}
      className={cx(Styles.tab, { [Styles.selected]: isSelected, [Styles.disabled]: isDisabled })}
    >
      {rendered}
    </div>
  )
}
